import { useState, useEffect, useContext } from "react";
import { useParams } from "react-router-dom";
import { LoadingContext } from "../../../../../contexts/Loading/LoadingContext";
import { DashboardContext } from "../../../../../contexts/Dashboard/DashboardContext";
import { api, errorTreatment } from "../../../../../services/api";
import LoadingGraphics from "../../../../Loading/LoadingGraphics";
import "../../style.css";
import { AuthContext } from "../../../../../contexts/Authentication/AuthContext";
import { ChartBar } from "./chart";
import { TableList } from "./table";

interface Info {
  type: string
}
export interface Routes {
  data: {
    finished: {
      region?: string,
      until_11: {
        today: number,
        last_weekdays_avg: number,
        last_weeks_avg: number
      },
      until_14: {
        today: number,
        last_weekdays_avg: number,
        last_weeks_avg: number
      },
      after_14: {
        today: number,
        last_weekdays_avg: number,
        last_weeks_avg: number
      }
    }[],
    count: number,
    total: {
        until_11: {
          today: number,
          last_weekdays_avg: number,
          last_weeks_avg: number
        },
        until_14: {
          today: number,
          last_weekdays_avg: number,
          last_weeks_avg: number
        },
        after_14: {
          today: number,
          last_weekdays_avg: number,
          last_weeks_avg: number
        }
    }
  }
}

export const RoutesFinishedOnInterval = ({type}: Info) => {
  const { changeVisibility } = useContext(LoadingContext);
  const { reloadComponent } = useContext(DashboardContext);
  const { shortToken , id, mode } = useParams();
  const { hasShortToken} = useContext(AuthContext);

  let routeRoutes: string;
  const [routes, setRoutes] = useState<Routes["data"]>({
    finished: [
      {
        region: "", 
        until_11: { today: 0, last_weekdays_avg: 0, last_weeks_avg: 0 },
        until_14: { today: 0, last_weekdays_avg: 0, last_weeks_avg: 0 },
        after_14: { today: 0, last_weekdays_avg: 0, last_weeks_avg: 0 }
      }
    ],
    count: 0,
    total: {
      until_11: { today: 0, last_weekdays_avg: 0, last_weeks_avg: 0 },
      until_14: { today: 0, last_weekdays_avg: 0, last_weeks_avg: 0 },
      after_14: { today: 0, last_weekdays_avg: 0, last_weeks_avg: 0 }
    }
  });
  const [completeRequisition, setCompleteRequisition] = useState(false);

  if (hasShortToken) {
    routeRoutes = `/routes/finished-on-intervals?graphic_id=chartRoutesFinishedOnInterval&short_token=${shortToken}&screen_id=${id}`;
  } else {
    routeRoutes = `/routes/finished-on-intervals?graphic_id=chartRoutesFinishedOnInterval&screen_id=${id}`;
  }

  useEffect(() => {
    changeVisibility(true);
    const fetchData = async () => {
      try {
        await requisition();
      } finally {
        changeVisibility(false);
        setCompleteRequisition(true);
      }
    };
    fetchData();
    if (mode === "view") {
      const intervalId = setInterval(() => {
        requisition();
      }, 60000);
      return () => clearInterval(intervalId);
    }
  }, []);

  async function requisition() {
    return await api
      .get(routeRoutes)
      .then((routes: Routes) => {
        setRoutes(routes.data);
      })
      .catch((error) => {
        errorTreatment(error);
      });
  }

  return completeRequisition && !reloadComponent ? (
    type === 'chart' ? (
      <div id="chart-routes-finished-on-interval" className="h100">
        <ChartBar data={routes} />
      </div>
    ) : (
      <div id="table-routes-finished-on-interval" className="h100">
        <TableList data={routes} />
      </div>
    )
  ) : (
    <LoadingGraphics/>
  );
};
